import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { cn } from '../../lib/utils';

const SortableCategoryRow = ({ category, children, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: category.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={onClick}
      className={cn(
        'p-4 border-b border-border/50 bg-background transition-colors cursor-pointer active:bg-accent touch-manipulation bl-indicator',
        isDragging && 'opacity-50 z-10 relative'
      )}
    >
      {children}
    </div>
  );
};

export default SortableCategoryRow;
